import { render, staticRenderFns } from "./main-banner.vue?vue&type=template&id=0180e418&"
import script from "./main-banner.vue?vue&type=script&lang=js&"
export * from "./main-banner.vue?vue&type=script&lang=js&"
import style0 from "./main-banner.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./main-banner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports